<template lang="html">
	<div class="signature-container">
    <div v-if="active" v-bind:class="{ 'alert alert-success': status == 'success', 'alert alert-danger': status == 'danger' }" role="alert" id="signature-alert">
      {{ messageText }}
    </div>
		<div v-if="emailEdit">
			<div><strong>Changing the email will send a new email to the new address and make the document inaccessible from the previous address.</strong></div>
			<div>Current Email: {{ currentEmail }}</div>
			<input class="email-input" type="text" v-model="changedEmail">
			<button @click="changeEmail()">Change</button>
		</div>
		<table class="mt-5 fl-table" v-bind:class="{ deactive: document.cancelled_at }" v-for="(document, documentIndex) in documents">
			<thead>
				<tr>
					<th
						colspan="8"
						style="background-color: #333; text-align: left;"
					>
						<a style="color: white" target="_blank" :href="`/api/signatures/download/${document.request_id}`" v-if="document.file">{{ document.file.file_name }}</a>

					</th>
					<th colspan="1"
						style="background-color: #333; text-align: left;">
						<a id="document-cancel-button" v-bind:class="{ deactive: document.status === 'cancelled' || document.status === 'signed' }" style="color: white; float: right" href="javascript:;" @click.prevent="cancel(document)">Cancel</a>
					</th>
				</tr>
				<tr>
					<th>Name</th>
					<th>Email</th>
					<th>Status</th>
					<th>Conflict</th>
					<th>Viewed At</th>
					<th>Reminded At</th>
					<th>Signed At</th>
					<th>Cancel Auto Remind</th>
					<th>Action</th>
				</tr>
			</thead>
			<tbody>
				<tr style="padding: 5px;" v-for="(signatory, signatoryIndex) in document.signatories" :key="signatoryIndex">
					<td>{{ signatory.name }}</td>
					<td style="color: blue; cursor: pointer; text-decoration:underline;">
						<div @click="openChange(signatory, signatoryIndex, document)">{{ signatory.email }}</div>
					</td>
					<td>{{ signatory.status }}</td>
					<td style="max-width: 200px; overflow-x: scroll;">{{ signatory.data }}</td>
					<td>{{ formatDate(signatory.viewed_at) }}</td>
					<td>{{ formatDate(signatory.reminded_at) }}</td>
					<td>{{ formatDate(signatory.signed_at) }}</td>
					<td>
						<span v-if="signatory.stop_reminders == 1">
							Cancelled
						</span>
						<a v-else v-bind:class="{ deactive: signatory.status === 'cancelled' || signatory.signed_at || signatory.status === 'signed' }" href="javascript:;" @click.prevent="stopAutoRemind(signatory, document)">Cancel</a>
					</td>
					<td>
						<a v-if="document.article.granular_status_id !== '022_010'" v-bind:class="{ deactive: signatory.status === 'cancelled' || signatory.signed_at || request }" href="javascript:;" @click.prevent="remind(signatory, document)">Remind</a>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: ["article_id"],
	data: {
		documents: [],
		messageText: null,
		status: null,
		emailIndex: -1,
		emailEdit: false,
		changedEmail: null,
		changeDocument: null,
		request: false,
		active: false,
	},
	methods: {
		changeEmail: function() {
			let self = this;
			this.resetAlert();

			if (this.request) {
				return
			}

			if (!this.changedEmail || !this.changedEmail.includes('@') || !this.changedEmail.includes('.')) {
				this.updateAlert('Email needs to be in valid format.', 'danger');
				this.$forceUpdate();

				return;
			}

			if (this.changedEmail == this.currentEmail) {
				this.updateAlert("Email can't be the same as the previous email, to send another email hit remind for the signatory.", 'danger');
				this.$forceUpdate();

				return;
			}

			this.request = true;

			axios.put(`/v1/signatures/email/${this.changeDocument.request_id}`, {
        signatureId: this.changeDocument.signatories[this.emailIndex].signature_id,
        email: this.changedEmail,
      }) // Response is not used.
			.then(() => {
				self.request = false;
				self.updateAlert('Email change request successful', 'success');
				self.emailEdit = false;
				self.getArticleDocuments();
			})
			.catch(err => {
				self.request = false;
				self.updateAlert(`Email change request failed ${err}`, 'danger');
				self.$forceUpdate();
			});

		},
		openChange: function(signatory, index, doc) {
			this.changeDocument = doc;
			this.emailIndex = index
			this.emailEdit = true;
			this.currentEmail = signatory.email;
			this.changedEmail = "";
			this.$forceUpdate();
		},
		closeChange: function() {
			this.changeDocument = null;
			this.emailEdit = false;
			this.currentEmail = "";
			this.changedEmail = "";
			this.$forceUpdate();
		},
		getArticleDocuments: function() {
			let self = this;

			axios.get("/api/signatures/" + self.article_id)
				.then(function(response) {
					self.documents = response.data;
					self.$forceUpdate();
				})
		},
		remind: function(signatory, document) {
			let self = this;
			this.resetAlert();

			if (this.request) {
				return
			}

			this.request = true;

			axios.get(`/api/signatures/remind/${document.request_id}`, {
				params: {
					email: signatory.email
				}
			})
			.then(function(response) {
				self.request = false;
				self.updateAlert('Remind request sent', 'success');
				self.getArticleDocuments()
			})
			.catch(function(err) {
				self.request = false;
				self.updateAlert(`Remind request failed to send ${err}`, 'danger');
				console.log(err)
			});
		},
		cancel: function(doc) {
			const confirmationMessage = `Are you sure you want to Cancel?`;

			if (!confirm(confirmationMessage)) {
				return;
			}

			let self = this;
			this.resetAlert();

			if (this.request) {
				return;
			}

			let cancelButton = document.getElementById('document-cancel-button');
			cancelButton.classList.add('deactive');

			this.request = true;

			axios.get(`/api/signatures/cancel/${doc.request_id}`)
			.then(response => {
				self.request = false;
				self.updateAlert('Cancel request successful', 'success');
				cancelButton.classList.remove('deactive');
				self.getArticleDocuments();
			})
			.catch(err => {
				self.request = false;
				self.updateAlert(`Cancel request failed ${err}`, 'danger');
				cancelButton.classList.remove('deactive');
				self.$forceUpdate();
			});
		},
		
		stopAutoRemind: function(signatory, document) {
			const confirmationMessage = `Are you sure you want to cancel automatic reminders for this user?`;

			if (!confirm(confirmationMessage)) {
				return;
			}

      let self = this;
			this.resetAlert();

			if (this.request) {
				return;
			}

			this.request = true;

			axios.put(
				`/v1/signatures/stop-auto-remind/${signatory.signature_id}`,
				{},
			)
			.then(function(response) {
        self.request = false;
				self.updateAlert('Auto reminders cancelled successfully', 'success');
				self.getArticleDocuments();
			})
			.catch(function(err) {
				self.request = false;
				self.updateAlert(`Failed to cancel auto reminders: ${err.response?.data?.message || err.message}`, 'danger');
				self.$forceUpdate();
			});
		},
		updateAlert: function(text, status) {
			this.active = true;
			this.status = status;
			this.messageText = text;
			this.$forceUpdate();
		},
		resetAlert: function() {
			this.active = false;
			this.status = "";
			this.messageText = "";
			this.$forceUpdate();
		},
		formatDate: function(dateString) {
			if (!dateString) return '';
			return dateString.split(' ')[0];
		},
	},
	created() {
		this.getArticleDocuments();
	},
	updated() {
    	updateIFrameHeight(100);
	}
};
</script>

<style scoped>
	.fl-table {
		border-radius: 5px;
		font-size: 12px;
		font-weight: normal;
		border: 1px solid #F4F4F4;
		border-collapse: collapse;
		width: 100%;
		max-width: 100%;
		white-space: nowrap;
		background-color: white;
	}

	.fl-table td, .fl-table th {
		text-align: center;
		padding: 8px;
	}

	.fl-table td {
		border-right: 1px solid #f8f8f8;
		font-size: 12px;
	}

	.fl-table thead th {
		color: #ffffff;
		background: #324960;
	}

	.fl-table tr:nth-child(even) {
		background: #F8F8F8;
	}

	.fl-table-opaque {
		opacity: .7;
	}
	.signature-container {
		margin-bottom: 30px;
		overflow-x: scroll;
	}
	#signature-alert {
		margin-top: 20px;
	}
</style>
